window.theme = window.theme || {};

theme.Collection = (function() {
  var settings = {
    mediaQueryMediumUp: '(min-width: ' + theme.breakpoints.medium + 'px)'
  };

  var selectors = {
    filterSelection: '#FilterTags',
    sortSelection: '#SortBy',
    selectInput: '[data-select-input]'
  };

  function Collection(container) {
    this.container = container;
    this.ajaxinateInstance = null;
    this.isLoading = false;

    this.filterSelect = null;
    this.sortSelect = null;
    this.selects = [];

    this.initBreakpoints = this._initBreakpoints.bind(this);
    this.boundClickHandler = this._onContainerClick.bind(this);
    this.boundSortCaptureHandler = this._onSortToolbarCapture.bind(this);
    this.boundChangeHandler = this._onContainerChange.bind(this);
    this.boundPopstateHandler = this._onPopstate.bind(this);
    this.boundResizeHandler = this._onWindowResize.bind(this);

    this.mql = window.matchMedia(settings.mediaQueryMediumUp);
    this.mql.addListener(this.initBreakpoints);
    this.container.addEventListener('click', this.boundSortCaptureHandler, true);
    this.container.addEventListener('click', this.boundClickHandler);
    this.container.addEventListener('change', this.boundChangeHandler);
    window.addEventListener('popstate', this.boundPopstateHandler);
    window.addEventListener('resize', this.boundResizeHandler);

    this._initParams();
    this._refreshCollectionElements();
    this._bindStaticEnhancements();

    theme.Helpers.promiseStylesheet().then(
        function() {
          this._initBreakpoints();
        }.bind(this)
    );
  }

  Collection.prototype = Object.assign({}, Collection.prototype, {
    _initBreakpoints: function() {
      if (this.mql.matches) {
        slate.utils.resizeSelects(this.selects);
      }
    },
    _refreshCollectionElements: function() {
      this.filterSelect = this.container.querySelector(selectors.filterSelection);
      this.sortSelect = this.container.querySelector(selectors.sortSelection);
      this.selects = this.container.querySelectorAll(selectors.selectInput);

      if (this.sortSelect) {
        this.defaultSort = this._getDefaultSortValue();
      }

      if (this.selects.length) {
        this.selects.forEach(function(select) {
          select.classList.remove('hidden');
        });
      }

      this._initStickyObserver();
      this._applyDefaultFilterHeights();
      this._initAjaxinate();
      this._bindProductCardFeatures();
      this._alignProductInfo();
    },
    _bindStaticEnhancements: function() {
      this._bindCollectionSearch();
      this._bindAccessoriesTabs();
    },
    _bindProductCardFeatures: function() {
      var formsArr = this.container.querySelectorAll('[action="/cart/add"]');
      if (formsArr.length) {
        formsArr.forEach(function(form) {
          theme.AddItemToCart(form);
        });
      }
      theme.ProductItemSwatches();
    },
    _initStickyObserver: function() {
      if (this.filterObserver) {
        this.filterObserver.disconnect();
      }

      var target = this.container.querySelector('.collection-filter-operate');
      var sentinel = this.container.querySelector('.collection-filter-sentinel');
      if (!target || !sentinel) return;

      this.filterObserver = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (window.innerWidth < 1023 && entry.boundingClientRect.top <= 0) {
            target.classList.add('fixed');
          } else {
            target.classList.remove('fixed');
          }
        });
      }, { root: null, threshold: 1.0 });

      this.filterObserver.observe(sentinel);
    },
    _applyDefaultFilterHeights: function() {
      var self = this;
      this.container.querySelectorAll('.category-filters-section-title').forEach(function(item) {
        var parentArea = item.closest('.category-filters-area-section');
        if (!parentArea) return;
        var filtersBlock = parentArea.querySelector('.category-filters-area-list');
        if (!filtersBlock) return;

        if (filtersBlock.classList.contains('active')) {
          filtersBlock.style.height = 'auto';
          filtersBlock.style.height = (filtersBlock.clientHeight + 10) + 'px';
        } else {
          filtersBlock.style.height = '0px';
        }
      });

      this.container.querySelectorAll('.advanced-filters').forEach(function(filter) {
        var children = filter.querySelectorAll('li');
        if (children.length <= 5) return;

        var heightLimit = 0;
        for (var i = 0; i < children.length; i++) {
          heightLimit += children[i].offsetHeight;
          if (i === 4) break;
        }

        var showMoreOption = filter.nextElementSibling;
        if (showMoreOption) {
          filter.setAttribute('data-heigth_limit', heightLimit);
          filter.style.maxHeight = heightLimit + 'px';
          showMoreOption.style.display = 'inline-block';
          if (!showMoreOption.classList.contains('openedFilter')) {
            showMoreOption.innerHTML = showMoreOption.getAttribute('data-default-text');
          }
        }
      });
    },
    _initAjaxinate: function() {
      var paginationMode = this.container.getAttribute('data-pagination_mode');
      if (paginationMode === 'standart' || typeof Ajaxinate === 'undefined') return;

      this.ajaxinateInstance = new Ajaxinate({
        container: '#AjaxinateContainer',
        pagination: '#AjaxinatePagination',
        method: paginationMode,
        offset: 500
      });
    },
    _alignProductInfo: function() {
      var grid = this.container.querySelector('.CollectionGrid');
      if (!grid) return;

      grid.style.setProperty('--product-title-height', 'auto');
      var titleHeight = 0;
      this.container.querySelectorAll('.product-card').forEach(function(element) {
        element.querySelectorAll('.product-card__link-title').forEach(function(infoElement) {
          if (infoElement.clientHeight > titleHeight) titleHeight = infoElement.clientHeight;
        });
      });
      grid.style.setProperty('--product-title-height', titleHeight + 'px');
    },
    _onWindowResize: function() {
      var self = this;
      setTimeout(function() {
        self._alignProductInfo();
      }, 500);
    },
    _bindCollectionSearch: function() {
      if (!document.querySelector('.collection-search')) return;
      var searchElement = document.querySelector('.collection-search');
      var searchInput = searchElement.querySelector('.search-field');
      if (!searchInput) return;

      searchInput.addEventListener('focus', function() {
        var dropdown = document.querySelector('.search-box-dropdown');
        if (!dropdown) return;
        dropdown.style.display = 'block';
        searchInput.classList.add('dropdown-enabled');
        var box = document.querySelector('.search-box');
        if (box) box.classList.add('focus-active');
      });

      document.addEventListener('mouseup', function(e) {
        var box = document.querySelector('.search-box');
        if (!box || box.contains(e.target)) return;
        if (window.innerWidth > 749) {
          var dropdown = document.querySelector('.search-box-dropdown');
          var closeBtn = searchElement.querySelector('.search-close');
          searchInput.value = '';
          if (dropdown) {
            dropdown.classList.add('show-all');
            dropdown.style.display = 'none';
          }
          if (closeBtn) closeBtn.style.display = 'none';
          searchInput.classList.remove('dropdown-enabled');
        }
      });

      var closeButton = searchElement.querySelector('.search-close');
      if (closeButton) {
        closeButton.addEventListener('click', function() {
          searchInput.value = '';
          var dropdown = document.querySelector('.search-box-dropdown');
          if (window.innerWidth > 749) {
            if (dropdown) dropdown.classList.add('show-all');
          } else {
            var box = document.querySelector('.search-box');
            if (box) box.classList.remove('focus-active');
            if (dropdown) dropdown.style.display = 'none';
            searchInput.classList.remove('dropdown-enabled');
          }
        });
      }

      searchInput.addEventListener('input', function(evt) {
        var inputVal = evt.target.value.toLowerCase();
        if (closeButton) closeButton.style.display = 'block';
        var dropdown = document.querySelector('.search-box-dropdown');
        if (dropdown) dropdown.classList.remove('show-all');
        document.querySelectorAll('.search-box-dropdown .search-item').forEach(function(elem) {
          var itemVal = elem.innerText.toLowerCase();
          elem.style.display = itemVal.search(inputVal) === 0 ? 'block' : 'none';
        });
      });
    },
    _bindAccessoriesTabs: function() {
      if (document.querySelectorAll('.accessories-tab-title').length === 0) return;
      document.querySelectorAll('.accessories-tab-title').forEach(function(tabTitle) {
        tabTitle.onclick = function(evt) {
          var tabHandle = evt.target.getAttribute('data-tab-title');
          document.querySelectorAll('.accessories-tab-title').forEach(function(tabTitleTemp) {
            tabTitleTemp.classList.remove('tab-active');
          });
          evt.target.classList.add('tab-active');
          document.querySelectorAll('.accessories-tab-content').forEach(function(tabContentTemp) {
            tabContentTemp.classList.remove('tab-content-active');
          });
          var target = document.querySelector('.accessories-tab-content[data-tab-title=' + tabHandle + ']');
          if (target) target.classList.add('tab-content-active');
        };
      });
    },
    _setLoadingState: function(isLoading) {
      this.isLoading = isLoading;
      this.container.classList.toggle('is-loading', isLoading);
      var sidebar = this.container.querySelector('.collection-sidebar');
      var collection = this.container.querySelector('#Collection');
      if (sidebar) sidebar.classList.toggle('is-loading', isLoading);
      if (collection) collection.classList.toggle('is-loading', isLoading);
    },
    _extractPathAndQuery: function(url) {
      try {
        var parsed = new URL(url, window.location.origin);
        return parsed.pathname + parsed.search;
      } catch (e) {
        return url;
      }
    },
    _buildCollectionUrlFromForm: function(formEl) {
      var formData = new FormData(formEl);
      var searchParams = new URLSearchParams(formData).toString();
      var pathname = window.location.pathname;
      return pathname + (searchParams ? '?' + searchParams : '');
    },
    _replaceCollectionAreasFromHtml: function(html) {
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, 'text/html');
      var nextSidebar = doc.querySelector('.collection-sidebar');
      var nextCollection = doc.querySelector('#Collection');
      var currentSidebar = this.container.querySelector('.collection-sidebar');
      var currentCollection = this.container.querySelector('#Collection');

      if (!nextSidebar || !nextCollection || !currentSidebar || !currentCollection) {
        return false;
      }

      currentSidebar.replaceWith(nextSidebar);
      currentCollection.replaceWith(nextCollection);
      this._refreshCollectionElements();
      return true;
    },
    _requestAndRender: function(url, shouldPushState) {
      var self = this;
      if (this.isLoading) return;

      this._setLoadingState(true);
      fetch(url, {
        credentials: 'same-origin',
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
          .then(function(response) {
            if (!response.ok) throw new Error('collection fetch failed');
            return response.text();
          })
          .then(function(html) {
            var replaced = self._replaceCollectionAreasFromHtml(html);
            if (!replaced) {
              window.location.href = url;
              return;
            }

            if (shouldPushState) {
              window.history.pushState({ collectionAsync: true }, '', url);
            }
          })
          .catch(function() {
            window.location.href = url;
          })
          .finally(function() {
            self._setLoadingState(false);
          });
    },
    _navigateToCollectionUrl: function(url, shouldPushState) {
      var finalUrl = this._extractPathAndQuery(url);
      this._requestAndRender(finalUrl, shouldPushState !== false);
    },
    _onPopstate: function() {
      this._navigateToCollectionUrl(window.location.pathname + window.location.search, false);
    },
    _toggleCollapsePanel: function(trigger) {
      var panelId = trigger.getAttribute('data-collapse-panel');
      if (!panelId) return;
      var panel = this.container.querySelector('#' + panelId);
      if (!panel) return;

      var currentActive = this.container.querySelector('.panel-heading.collapse.active');
      if (currentActive && currentActive !== trigger) {
        this._toggleCollapsePanel(currentActive);
      }

      if (!panel.classList.contains('active')) {
        trigger.classList.add('active');
        panel.classList.add('active');
        panel.style.height = 'auto';
        var height = panel.clientHeight + 'px';
        panel.style.height = '0px';
        setTimeout(function() {
          panel.style.height = height;
        }, 0);
      } else {
        panel.style.height = '0px';
        panel.addEventListener('transitionend', function() {
          panel.classList.remove('active');
          trigger.classList.remove('active');
        }, { once: true });
      }
    },
    _toggleFilterSection: function(trigger) {
      var parentArea = trigger.closest('.category-filters-area-section');
      if (!parentArea) return;
      var filtersBlock = parentArea.querySelector('.category-filters-area-list');
      if (!filtersBlock) return;

      if (!filtersBlock.classList.contains('active')) {
        trigger.classList.add('active');
        filtersBlock.classList.add('active');
        filtersBlock.style.height = 'auto';
        var height = (filtersBlock.clientHeight + 10) + 'px';
        filtersBlock.style.height = '0px';
        setTimeout(function() {
          filtersBlock.style.height = height;
        }, 0);
      } else {
        filtersBlock.style.height = '0px';
        trigger.classList.remove('active');
        filtersBlock.classList.remove('active');
      }
    },
    _toggleShowMore: function(button) {
      var filtersList = button.previousElementSibling;
      if (!filtersList) return;
      var heightLimit = filtersList.getAttribute('data-heigth_limit');
      var defaultText = button.getAttribute('data-default-text');

      if (button.classList.contains('openedFilter')) {
        filtersList.style.maxHeight = heightLimit + 'px';
        button.classList.remove('openedFilter');
        button.innerHTML = defaultText;
      } else {
        var filterBlockLength = 0;
        filtersList.querySelectorAll('li').forEach(function(item) {
          filterBlockLength += item.offsetHeight;
        });
        filtersList.style.maxHeight = filterBlockLength + 'px';
        button.classList.add('openedFilter');
        button.innerHTML = theme.strings.show_less;
      }
    },
    _toggleMobileSidebar: function(open) {
      var sidebarEl = this.container.querySelector('.collection-sidebar');
      if (!sidebarEl) return;
      sidebarEl.classList.toggle('show', open);
      document.body.classList.toggle('show_overlay', open);
    },
    _onSortToolbarCapture: function(e) {
      var sortLabel = e.target.closest('.filters-toolbar__label');
      if (sortLabel && this.container.contains(sortLabel)) {
        e.preventDefault();
        e.stopPropagation();
        var sortWrapper = sortLabel.parentElement
            ? sortLabel.parentElement.querySelector('.filters-toolbar__input-wrapper')
            : null;
        if (sortWrapper) sortWrapper.classList.toggle('active');
        sortLabel.classList.toggle('active');
        return;
      }

      var sortItem = e.target.closest('.sort-item');
      if (sortItem && this.container.contains(sortItem)) {
        e.preventDefault();
        e.stopPropagation();
        if (!sortItem.classList.contains('selected')) {
          var wrapper = sortItem.closest('.filters-toolbar__input-wrapper');
          if (wrapper) wrapper.classList.remove('active');
          var activeLabel = this.container.querySelector('.filters-toolbar__label.active');
          if (activeLabel) activeLabel.classList.remove('active');

          var sortSelectEl = this.container.querySelector('#SortBy');
          var sortValue = sortItem.getAttribute('data-value');
          if (sortSelectEl && sortValue) {
            sortSelectEl.value = sortValue;
            sortSelectEl.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      }
    },
    _onContainerClick: function(e) {
      var collapseTrigger = e.target.closest('.panel-heading.collapse');
      if (collapseTrigger && this.container.contains(collapseTrigger)) {
        e.preventDefault();
        this._toggleCollapsePanel(collapseTrigger);
        return;
      }

      var sectionTitle = e.target.closest('.category-filters-section-title');
      if (sectionTitle && this.container.contains(sectionTitle)) {
        e.preventDefault();
        this._toggleFilterSection(sectionTitle);
        return;
      }

      var showMore = e.target.closest('.show_more_options');
      if (showMore && this.container.contains(showMore)) {
        e.preventDefault();
        this._toggleShowMore(showMore);
        return;
      }

      if (e.target.closest('.open_mobile_sidebar')) {
        e.preventDefault();
        this._toggleMobileSidebar(true);
        return;
      }

      if (e.target.closest('.close-collection-sidebar')) {
        e.preventDefault();
        this._toggleMobileSidebar(false);
        return;
      }

      var applyButton = e.target.closest('.apply-button');
      if (applyButton && this.container.contains(applyButton)) {
        e.preventDefault();
        var filtersForm = this.container.querySelector('.filter-form');
        if (filtersForm) {
          this._navigateToCollectionUrl(this._buildCollectionUrlFromForm(filtersForm));
        }
        this._toggleMobileSidebar(false);
        return;
      }

      var clearFiltersLink = e.target.closest('.active-filters__clear');
      if (clearFiltersLink && this.container.contains(clearFiltersLink)) {
        e.preventDefault();
        this._navigateToCollectionUrl(clearFiltersLink.getAttribute('href'));
        return;
      }

      var layoutButton = e.target.closest('[data-action="change-layout"]');
      if (layoutButton && this.container.contains(layoutButton)) {
        e.preventDefault();
        if (layoutButton.classList.contains('is-selected')) return;

        var buttonParent = layoutButton.closest('.filters-toolbar');
        var newLayoutMode = layoutButton.getAttribute('data-layout-mode');
        fetch(window.routes.cartUrl + '/update.js', {
          body: JSON.stringify({ attributes: { collection_layout: newLayoutMode } }),
          credentials: 'same-origin',
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          }
        });

        if (buttonParent) {
          var selected = buttonParent.querySelector('.collection__layout-button.is-selected');
          if (selected) selected.classList.remove('is-selected');
        }
        layoutButton.classList.add('is-selected');
        this.container.querySelectorAll('.Collection-wrapper .product-item-block').forEach(function(productBlock) {
          if (newLayoutMode === 'grid') {
            productBlock.classList.remove('view-mode-list');
            productBlock.classList.add('view-mode-grid');
          } else {
            productBlock.classList.add('view-mode-list');
            productBlock.classList.remove('view-mode-grid');
          }
        });
        return;
      }

      var filterAction = e.target.closest('.advanced-filter a');
      if (filterAction && this.container.contains(filterAction)) {
        e.preventDefault();
        var parentFilterNode = filterAction.closest('.advanced-filter');
        if (!parentFilterNode) return;
        var filterInput = parentFilterNode.querySelector('[type="checkbox"]');
        if (filterInput) {
          filterInput.checked = !filterInput.checked;
        }

        if (filterAction.classList.contains('cust-price-range')) {
          var priceGte = this.container.querySelector('#price_gte');
          var priceLte = this.container.querySelector('#price_lte');
          if (priceGte) priceGte.removeAttribute('value');
          if (priceLte) priceLte.removeAttribute('value');
          if (filterInput && filterInput.checked) {
            this.container.querySelectorAll("input[name='cust-price-range']").forEach(function(cb) {
              if (cb !== filterInput) cb.checked = false;
            });
            var values = filterInput.value.split('-');
            if (priceGte && values[0]) priceGte.value = values[0];
            if (priceLte && values[1]) priceLte.value = values[1];
          }
        }

        if (window.innerWidth > 1023) {
          var filterForm = filterAction.closest('form');
          if (filterForm) {
            this._navigateToCollectionUrl(this._buildCollectionUrlFromForm(filterForm));
          }
        }
      }
    },
    _onContainerChange: function(e) {
      var el = e.target;

      if (el.id === 'SortBy') {
        this._onSortChange();
        return;
      }

      if (el.matches('.filter-group-display__price-range-input')) {
        var formEl = el.closest('form');
        if (formEl) this._navigateToCollectionUrl(this._buildCollectionUrlFromForm(formEl));
        return;
      }

      if (el.matches('.price_range')) {
        var rangeForm = el.closest('form');
        if (!rangeForm) return;

        var prices = [];
        var priceRangeInputs = rangeForm.querySelectorAll('.filter-group-display__price-range-input');
        var container = el.closest('.price_range_container');
        if (container) {
          container.querySelectorAll('.price_range').forEach(function(item) {
            prices.push(item.value * 1);
          });
          if (priceRangeInputs.length) {
            priceRangeInputs[0].value = Math.min.apply(null, prices);
            priceRangeInputs[1].value = Math.max.apply(null, prices);
          }
        }
        this._navigateToCollectionUrl(this._buildCollectionUrlFromForm(rangeForm));
      }
    },

    _initParams: function() {
      this.queryParams = {};
      if (location.search.length) {
        var aKeyValue;
        var aCouples = location.search.substr(1).split('&');
        for (var i = 0; i < aCouples.length; i++) {
          aKeyValue = aCouples[i].split('=');
          if (aKeyValue.length > 1) {
            this.queryParams[
                decodeURIComponent(aKeyValue[0])
                ] = decodeURIComponent(aKeyValue[1]);
          }
        }
      }
    },

    _onSortChange: function() {
      var paramsObj = new URLSearchParams(window.location.search);
      paramsObj.set('sort_by', this._getSortValue());
      paramsObj.delete('page');
      var params = decodeURIComponent(paramsObj.toString());
      var url = window.location.pathname + (params ? '?' + params : '');
      this._navigateToCollectionUrl(url);
    },

    _onFilterChange: function() {
      this._navigateToCollectionUrl(this._getFilterValue());
    },

    _getFilterValue: function() {
      return this.filterSelect.value;
    },

    _getSortValue: function() {
      return this.sortSelect.value || this.defaultSort;
    },

    _getDefaultSortValue: function() {
      return this.sortSelect.dataset.defaultSortby;
    },

    onUnload: function() {
      function clearLayoutSettings() {
        var headers = new Headers({ 'Content-Type': 'application/json' });
        var request = {
          method: 'POST',
          headers: headers,
          body: JSON.stringify({ attributes: { 'collection_layout': '' } })
        };
        fetch('/cart/update.js', request)
            .then(function(response) {
            });
      }
      clearLayoutSettings();
      this.mql.removeListener(this.initBreakpoints);
      this.container.removeEventListener('click', this.boundSortCaptureHandler, true);
      this.container.removeEventListener('click', this.boundClickHandler);
      this.container.removeEventListener('change', this.boundChangeHandler);
      window.removeEventListener('popstate', this.boundPopstateHandler);
      window.removeEventListener('resize', this.boundResizeHandler);
      if (this.filterObserver) this.filterObserver.disconnect();
    }
  });

  return Collection;
})();


document.addEventListener('DOMContentLoaded', function() {
  var sections = new theme.Sections();
  sections.register('collection-template', theme.Collection);
});